import React, { FunctionComponent } from 'react'

import { ColorsV2 } from '../../../design-system/colors_v2'
import { Icon } from '../../../components/shared'

import styles from './ToolbarButton.module.scss'

export const AddDatamatrixButton: FunctionComponent<{ onClick: () => void }> = ({ onClick }) => (
  <div role="button" className={styles.button} onClick={onClick}>
    <Icon icon="barcode" size="pico" color={ColorsV2.backgroundDark3} />
  </div>
)
